import {
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Combustiveis } from '../model/RetornoGetCombustiveis';

@Component({
  selector: 'app-mostrar-preco',
  templateUrl: './mostrar-preco.component.html',
  styleUrls: ['./mostrar-preco.component.scss'],
})
export class MostrarPrecoComponent {
  @Input() combustivel!: Combustiveis;
  @Output() combustivelParaAlterar = new EventEmitter<AlteracaoPreco>();
  @Output() habilitarDesabilitarCombustivel = new EventEmitter<Combustiveis>();


  alterarValor(comb: Combustiveis, tipo: string) {
    comb.disponivelParaVenda = 1;

    let e: AlteracaoPreco = {
      combustivel: comb,
      tipoDeAlteracao: tipo,
    };
    this.combustivelParaAlterar.emit(e);
  }

  handleHabilitarCombustivel($event: Event, combustivel: Combustiveis) {
    // Se for dasabilitar desconsiderar preços
    let checked = ($event.target as HTMLInputElement).checked;

    if (!checked) {
      combustivel.disponivelParaVenda = 0;
      this.habilitarDesabilitarCombustivel.emit(combustivel);
    }
  }
}

export interface AlteracaoPreco {
  combustivel: Combustiveis;
  tipoDeAlteracao: string;
}
